"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var bank_1 = tslib_1.__importDefault(require("./bank"));
var BankRecResource = /** @class */ (function (_super) {
    tslib_1.__extends(BankRecResource, _super);
    function BankRecResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BankRecResource.endpoint = '/bankrec';
    BankRecResource.MODEL_NAME = 'bankrec';
    BankRecResource.related = {
        bank: bank_1.default,
    };
    return BankRecResource;
}(base_1.default));
exports.default = BankRecResource;
//# sourceMappingURL=bankrec.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/bankrec.js
// module id = pIdJ
// module chunks = 0